import { render, staticRenderFns } from "./ImportSalary.vue?vue&type=template&id=4d86c88d&scoped=true"
import script from "./ImportSalary.vue?vue&type=script&lang=js"
export * from "./ImportSalary.vue?vue&type=script&lang=js"
import style0 from "./ImportSalary.vue?vue&type=style&index=0&id=4d86c88d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d86c88d",
  null
  
)

export default component.exports